<script lang="ts">
  import Header from "../../Shared/Header.svelte";

  export var title: string="";
</script>

<Header {title} backUrl="#/" />
